<template>
  <b-card>
    <b-card-header>
      <h4 class="title">
        لیست اتاق ها
      </h4>
    </b-card-header>
    <b-card-body>
      <b-overlay :show="onProgress">
        <div ref="resultTable">
          <b-table
            :fields="fields"
            :items="items"
            hover
            striped
            responsive
          >
            <template #table-busy>
              <div class="text-center text-info my-2">
                <b-spinner class="align-middle" />
                <strong> درحال دریافت اطلاعات...</strong>
              </div>
            </template>

            <template #cell(is_active)="data">
              <b-avatar
                  :id="`room-row-${data.item.id}`"
                  size="32"
                  :variant="data.value ? 'light-success': 'light-danger'"
              >
                <feather-icon
                    :icon="data.value ? 'CheckIcon': 'XIcon'"
                />
              </b-avatar>
            </template>
            <template #cell(action)="data">
              <b-dropdown
                text="عملیات"
                variant="outline-primary"
              >
                <b-dropdown-item :to="{name: 'Room_Edit', params:{id: data.item.id}}">
                  <feather-icon
                    icon="EditIcon"
                    class="text-warning"
                  />
                  ویرایش
                </b-dropdown-item>
              </b-dropdown>
            </template>

          </b-table>
          <b-pagination
            v-model="currentPage"
            class="mt-2"
            :total-rows="totalRows"
            :per-page="perPage"
          />
        </div>
      </b-overlay>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardHeader,
  BCardBody,
  BTable,
  BSpinner,
  BBadge,
  BDropdown,
  BDropdownItem,
  BOverlay,
  BPagination, BFormInput, BCollapse, BFormGroup, BButton, VBToggle, BAvatar,
} from 'bootstrap-vue'
import VSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'

export default {
  name: 'Room_List',
  components: {
    BAvatar,
    BButton,
    VSelect,
    BFormGroup,
    BCollapse,
    BFormInput,
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BTable,
    BSpinner,
    BBadge,
    BDropdown,
    BDropdownItem,
    BOverlay,
    BPagination,
  },
  directives: {
    Ripple,
    'b-toggle': VBToggle,
  },
  data() {
    return {
      fields: [
        {
          key: 'id',
          label: 'شناسه',
        },
        {
          key: 'name',
          label: 'نام اتاق',
        },
        {
          key: 'creator.name',
          label: 'سازنده',
        },
        {
          key: 'is_active',
          label: 'وضعیت',
        },
        {
          key: 'action',
          label: 'عملیات',
        },
      ],
      items: [],
      currentPage: 1,
      totalRows: 0,
      perPage: 0,
      onProgress: true,
    }
  },

  mounted() {
    this.getRoomList()
  },
  methods: {
    getRoomList() {
      this.onProgress = true
      this.$http.get('rooms', {
        params: {
          page: this.currentPage,
        },
      })
        .then(({ data }) => {
          if (data.status) {
            this.items = data.rooms
            this.currentPage = data.meta.current_page
            this.totalRows = data.meta.total
            this.perPage = data.meta.per_page
          } else {
            this.$bvToast.toast(data.message ?? 'در دریافت لیست اتاق جلسات خطایی رخ داده', {
              title: 'حطا',
              toaster: 'b-toaster-top-right',
              variant: 'danger',
            })
          }
        })
        .catch(error => {
          this.$bvToast.toast(error.response.data.message, {
            title: 'خطا در دریافت اطلاعات',
            toaster: 'b-toaster-top-right',
            variant: 'danger',
          })
        })
        .finally(() => {
          this.onProgress = false
        })
    },
  },
  watch: {
    currentPage(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.$router.push({
          name: 'Room_Update',
          query: { page: this.currentPage },
        })
        this.items = []
        this.getRoomList()
      }
    },
  },
}
</script>

<style>

</style>
